import React from 'react';
import { Link } from 'react-router-dom';

const aboutLinks = [
  { label: 'Home',          to: '/it-training' },
  { label: 'About Us',      to: '/it-training' },
  { label: 'Courses',       to: '/programming' },
  { label: 'Testimonials',  to: '/it-training' },
  { label: 'Gallery',       to: '/it-training' },
  { label: 'FAQ',           to: '/it-training' },
  { label: 'Blog',          to: '/blog' },
  { label: 'Our Team',      to: '/it-training' },
  { label: 'Google Review', to: '/it-training' },
  { label: 'Contact Us',    to: '/contact' },
];

const programmingLinks = [
  { label: 'Python Training',          to: '/course/python-training' },
  { label: 'Python With AI Training',  to: '/course/python-ai-training' },
  { label: 'Python With ML Training',  to: '/course/python-ml-training' },
  { label: 'Machine Learning',         to: '/course/machine-learning' },
  { label: 'Android With IOT Training',to: '/course/android-iot-training' },
  { label: 'IOT Training',             to: '/course/iot-training' },
  { label: 'PHP/MySQL Training',       to: '/course/php-mysql-training' },
  { label: 'ASP.Net Training',         to: '/course/aspnet-training' },
  { label: 'Java Training',            to: '/course/java-training' },
  { label: 'Odoo Training',            to: '/course/odoo-training' },
  { label: 'Big Data Training',        to: '/course/big-data-training' },
];

const nonProgLinks = [
  { label: 'SEO Training',            to: '/course/seo-training' },
  { label: 'Software Testing',        to: '/course/software-testing' },
  { label: 'Web Design Training',     to: '/course/web-design-training' },
  { label: 'Graphics Design Training',to: '/course/graphics-design-training' },
  { label: 'Digital Marketing',       to: '/course/digital-marketing-nonprog' },
  { label: 'Business Development',    to: '/course/business-development-training' },
];

export default function ITTrainingFooter() {
  return (
    <footer className="itf">
      <div className="itf__body">
        <div className="itf__inner">

          {/* Col 1 – About */}
          <div className="itf__col">
            <h4 className="itf__col-title">About Vedanskrix</h4>
            <ul className="itf__list">
              {aboutLinks.map(l => (
                <li key={l.label}><Link to={l.to}>{l.label}</Link></li>
              ))}
            </ul>
          </div>

          {/* Col 2 – IT Training (Web) */}
          <div className="itf__col">
            <h4 className="itf__col-title">IT Training (Web)</h4>
            <ul className="itf__list">
              {programmingLinks.map(l => (
                <li key={l.label}><Link to={l.to}>{l.label}</Link></li>
              ))}
              <li><Link to="/programming" className="itf__more">More...</Link></li>
            </ul>
          </div>

          {/* Col 3 – Non Programming + Mobile */}
          <div className="itf__col">
            <h4 className="itf__col-title">Non Programming</h4>
            <ul className="itf__list">
              {nonProgLinks.map(l => (
                <li key={l.label}><Link to={l.to}>{l.label}</Link></li>
              ))}
            </ul>

            <h4 className="itf__col-title" style={{marginTop: '20px'}}>IT Training (Mobile)</h4>
            <ul className="itf__list">
              <li><Link to="/course/android-training">Android Training</Link></li>
              <li><Link to="/course/iphone-training">iPhone Training</Link></li>
            </ul>
          </div>

          {/* Col 4 – Logo + Contact */}
          <div className="itf__col itf__col--brand">
            <div className="itf__logo-row">
              <img src="/logo.jpg" alt="Vedanskrix" className="itf__logo" />
              <div className="itf__logo-text">
                <span className="itf__logo-name">VEDANSKRIX</span>
                <span className="itf__logo-sub">Web LLP</span>
              </div>
            </div>

            <div className="itf__contact-block">
              <p><strong>H.O : Ahmedabad</strong></p>
              <p>E-106 Akshardham Heights,<br />S.P. Ring Road, Vastral Road,<br />Ahmedabad, Gujarat 382418</p>
              <p><strong>Email:</strong> vedanskrix@gmail.com</p>
              <p><strong>Web:</strong> vedanskrix.com</p>
            </div>

            {/* Social icons */}
            <div className="itf__socials">
              <a href="https://wa.me/918758637022" className="itf__social" target="_blank" rel="noreferrer" aria-label="WhatsApp">
                <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 5.2a6.55 6.55 0 0 0-5.66 9.86L5.5 18.8l3.84-.82A6.55 6.55 0 1 0 12 5.2Z"/></svg>
              </a>
              <a href="#" className="itf__social" aria-label="Facebook" onClick={e=>e.preventDefault()}>
                <svg viewBox="0 0 24 24" fill="currentColor"><path d="M13.2 18.5v-5.6h2l.3-2.3h-2.3V9.1c0-.67.19-1.12 1.15-1.12h1.23V5.92c-.21-.03-.95-.09-1.8-.09-1.79 0-3.01 1.09-3.01 3.09v1.72H9v2.3h2.02v5.56h2.18Z"/></svg>
              </a>
              <a href="#" className="itf__social" aria-label="Instagram" onClick={e=>e.preventDefault()}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="6.2" y="6.2" width="11.6" height="11.6" rx="3"/><circle cx="12" cy="12" r="2.9"/><circle cx="16.1" cy="7.9" r="0.7" fill="currentColor" stroke="none"/></svg>
              </a>
              <a href="#" className="itf__social" aria-label="YouTube" onClick={e=>e.preventDefault()}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M18.2 9.2c-.14-.54-.57-.97-1.11-1.11C16.1 7.8 12 7.8 12 7.8s-4.1 0-5.1.3c-.54.14-.97.57-1.11 1.11-.3 1-.3 2.8-.3 2.8s0 1.8.3 2.8c.14.54.57.97 1.11 1.11 1 .3 5.1.3 5.1.3s4.1 0 5.1-.3c.54-.14.97-.57 1.11-1.11.3-1 .3-2.8.3-2.8s0-1.8-.3-2.8Z"/><path d="m10.6 14.4 3.4-2.4-3.4-2.4v4.8Z" fill="currentColor" stroke="none"/></svg>
              </a>
            </div>
          </div>

        </div>
      </div>

      {/* Bottom bar */}
      <div className="itf__bottom">
        <div className="itf__bottom-inner">
          <span>© {new Date().getFullYear()} Vedanskrix Web LLP — All Rights Reserved</span>
          <div className="itf__bottom-links">
            <Link to="/">Sitemap</Link>
            <Link to="/contact">Privacy Policy</Link>
            <Link to="/contact">Contact</Link>
          </div>
          <a href="/contact" className="itf__inquiry-btn">Quick Inquiry</a>
        </div>
      </div>
    </footer>
  );
}
